import _ from "lodash";
import React from "react";
import UIBaseComponent from "UIComponents/UIBaseComponent";
import { ToggleSwitch } from "@toddle-edu/ds-web";
import { connect } from "react-redux";
import { createAssessmentTool } from "AssessmentToolSetup/modules/AssessmentToolSetupModule";
import { removeAssessmentTool } from "Assessments/modules/AssessmentModule";
import classes from "./FinalRemark.scss";

const styles = {
  containerStyle: {
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
  },
  labelContainerStyle: {
    width: "fit-content",
    marginBottom: "0px",
  },
};
class FinalRemark extends UIBaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: false,
    };
  }

  componentDidMount = () => {
    const { commentTool } = this.props;
    this.setState({ isChecked: !_.isEmpty(commentTool) });
  };

  onChangeToggleSwitch = async e => {
    const isChecked = e.target.checked;
    this.setState({ isChecked });

    const {
      createAssessmentTool,
      removeAssessmentTool,
      parentId,
      parentType,
      assessmentId,
      commentTool,
      portalType,
    } = this.props;

    if (isChecked) {
      await createAssessmentTool({
        type: "COMMENT",
        parentId,
        parentType,
        assessmentId,
        portalType,
      });
    } else {
      await removeAssessmentTool({
        id: _.get(commentTool, "node.assessmentToolItem.id"),
        type: "COMMENT",
        parentId,
        parentType,
        portalType,
      });
    }
  };

  renderToggleSwitch = () => {
    const { mode, commentTool, testId } = this.props;
    const { isChecked } = this.state;
    return (
      <div className={classes.container}>
        <ToggleSwitch
          onChange={this.onChangeToggleSwitch}
          checked={isChecked}
          disabled={mode !== "edit" || (isChecked && _.isEmpty(commentTool))}
          testId={testId ?? "assessmentDetailsEdit-finalRemark"}
        />
      </div>
    );
  };

  renderView = () => this.renderToggleSwitch();

  renderEdit = () => this.renderToggleSwitch();
}

const mapStateToProps = (state, ownProps) => {
  const { assessmentTools = [] } = ownProps;

  const { assessmentId = "" } = state.assessment.assessmentData;
  const commentTool = _.find(
    assessmentTools?.edges,
    ({ node }) => node?.assessmentToolType === "COMMENT"
  );

  return {
    assessmentId,
    commentTool,
    value: _.get(commentTool, "node.assessmentToolType"),
    containerStyle: styles.containerStyle,
    labelContainerStyle: styles.labelContainerStyle,
  };
};

const mapActionCreators = {
  createAssessmentTool,
  removeAssessmentTool,
};

export default connect(mapStateToProps, mapActionCreators)(FinalRemark);
